<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button defaultHref="/home"></ion-back-button>
    </ion-buttons>
    <ion-title>Paw-some Recipes</ion-title>
    <ion-buttons slot="primary">
      <ion-button [routerLink]="['/chats']"><ion-icon name="chatbox" slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/notifications']"><ion-icon name="notifications"
          slot="icon-only"></ion-icon></ion-button>
      <ion-button [routerLink]="['/account']"><ion-icon name="menu-outline" slot="icon-only"></ion-icon></ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content color="lightmimbo">
  <div class="ion-text-center ion-padding" *ngIf="isLoading">
    <ion-spinner color="primary"></ion-spinner>
  </div>
  <div *ngIf="!isLoading">
    <ion-grid>
      <ion-row>
        <ion-col class="ion-text-center">
          <ion-text class="title">{{loadedRecipe.name}}</ion-text>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-text class="description">
            {{loadedRecipe.description}}
          </ion-text>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <div class="recipe-info-box">
            <div class="info-grid">
              <div>
                <strong>Recipe Type:</strong><br>
                {{loadedRecipe.type}} for {{loadedRecipe.petTypeId == 1 ? 'dogs' : 'cats'}}
              </div>
              <div>
                <strong>Time Needed:</strong><br>
                {{loadedRecipe.timeNeeded +' mins'}}
              </div>
              <div>
                <strong>Serving Size:</strong><br>
                {{loadedRecipe.servingSize}}
              </div>
              <div>
                <strong>Total Yield:</strong><br>
                {{loadedRecipe.totalServing.replace(' per batch', '').replace(' grams', 'g')}}
              </div>
              <div class="storage-block">
                <strong>Storage:</strong><br>
                {{loadedRecipe.storage}}
              </div>
            </div>

            <hr>

            <div class="jump-link">
              <ion-accordion-group (ionChange)="toggleAccordion($event)"
                value="{{ isAccordionOpen ? 'first' : undefined }}">
                <ion-accordion value="first">
                  <ion-item slot="header" color="lightmimbo">
                    <strong><ion-label>{{ isAccordionOpen ? 'Hide Nutritional Facts' : 'View Nutritional Facts'
                        }}</ion-label>
                    </strong> </ion-item>
                  <div class="ion-padding light-background" slot="content">
                    <div class="nutrition-label">
                      <h2>Nutrition Facts</h2>
                      <p><strong>Serving size</strong> {{loadedRecipe.servingSize}}</p>
                      <hr class="thick" />
                      <p class="calories-label"><strong>Amount per serving</strong></p>
                      <p class="calories"><strong>Calories</strong> {{loadedRecipe.calories}}</p>
                      <hr class="thick" />
                      <div class="itemnutrition">
                        <span><strong>Total Fat</strong></span>
                        <span><strong>{{loadedRecipe.fat}}g</strong></span>
                      </div>
                      <div class="itemnutrition">
                        <span><strong>Protein</strong></span>
                        <span><strong>{{loadedRecipe.protein}}g</strong></span>
                      </div>
                      <div class="itemnutrition">
                        <span><strong>Total Carbohydrate</strong></span>
                        <span><strong>{{loadedRecipe.carbohydrates}}g</strong></span>
                      </div>
                      <div class="itemnutrition">
                        <span><strong>Fiber</strong></span>
                        <span><strong>{{loadedRecipe.fiber}}g</strong></span>
                      </div>

                      <hr />

                      <p class="footnote">
                        Values are approximate and may vary depending on ingredient brands, preparation methods, and
                        portion sizes.
                      </p>
                    </div>
                  </div>
                </ion-accordion>
              </ion-accordion-group>
            </div>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <img [src]="loadedRecipe.image" class="header-image" /><img />
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <div class="icons">
            <a style="color: #128c7e" [href]="'whatsapp://send?text=Doggos will love this recipe!! ' + url"
              data-action="share/whatsapp/share"><ion-icon name="logo-whatsapp" class="icon"></ion-icon></a>
            <ion-icon class="icon" name="copy-outline" (click)="copyLink()"></ion-icon>

            <ion-icon class="icon" name="share-social-outline" (click)="shareRecipe()"></ion-icon>
            <ion-button class="fav" *ngIf="!isLiked" (click)="AddToFav()">Save<ion-icon name="heart-outline"
                slot="start"></ion-icon></ion-button>
            <ion-button class="fav" *ngIf="isLiked" (click)="RemoveFromFav()">Saved <ion-icon name="heart"
                slot="start"></ion-icon></ion-button>
          </div>
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="prewrap" sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-text class="subtitle">Ingredients</ion-text>
          <div class="ingredients-list">{{loadedRecipe.ingredients}}</div>
        </ion-col>
      </ion-row>
      <ion-row><ion-col class="prewrap ion-text-center" sizeMd="10" offsetMd="1" sizeXl="8" offsetXl="2">
          <ion-text><span class="subtitle">Directions</span></ion-text>
          <div class="directions" [innerHTML]="newDirections">
          </div>
        </ion-col>
      </ion-row>
      <!-- <ion-row *ngIf="loadedRecipe.notes.length >0"><ion-col class="prewrap ion-text-center" sizeMd="10" offsetMd="1"
          sizeXl="8" offsetXl="2">
          <ion-text><span class="subtitle">Additional Info</span> </ion-text>
          <div class="directions">{{loadedRecipe.notes}}</div>
        </ion-col>
      </ion-row> -->
      <ion-row>
        <ion-col class="ion-text-center">
          <span class="bon-appetit-text" *ngIf="loadedRecipe.petTypeId == 1">🐶🦴 Bon Appétit! 🦴🐶</span>
          <span class="bon-appetit-text" *ngIf="loadedRecipe.petTypeId == 2">😺🍽️ Bon Appétit! 🍽️😺</span>
        </ion-col>
      </ion-row>
    </ion-grid>

    <ion-fab-button [routerLink]="['/recipelist']" [queryParams]="{fav: 'false'}"><ion-icon
        name="list-outline"></ion-icon></ion-fab-button>
  </div>
</ion-content>